import { render } from "./index.vue?vue&type=template&id=1baff925&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1baff925&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=1baff925&lang=scss"
script.render = render
script.__scopeId = "data-v-1baff925"

export default script